import { useCallback } from 'react';
import { atom, useRecoilState } from 'recoil';
import { localStorageEffect } from '../recoil';
export var LogLevel;
(function (LogLevel) {
    LogLevel["INFO"] = "INFO";
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["WARN"] = "WARN";
    LogLevel["ERROR"] = "ERROR";
})(LogLevel || (LogLevel = {}));
const loggerState = atom({
    key: 'loggerState',
    default: {
        logLevel: LogLevel.INFO,
        logEnabled: true,
    },
    effects: [localStorageEffect('elevate_logging_config')], // default value (aka initial value)
});
export function useLogger() {
    const [config, setConfig] = useRecoilState(loggerState);
    const onSetConfig = useCallback((config) => {
        setConfig(config);
    }, [config, setConfig]);
    const onLogMessage = useCallback((value, level = LogLevel.INFO) => {
        if (!config.logEnabled) {
            return;
        }
        if (level === LogLevel.ERROR) {
            console.error(value);
        }
        console.log(value);
    }, [config]);
    return [onLogMessage, config, onSetConfig];
}
